import React from "react";
import { useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";

import Root from "../../Components/Course/Root";
import ContinueTeaching from "./ContinueTeaching";

const Module = (props) => {
  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  const classes = useStyles();

  return (
    <Grid container>
      <Grid
        item
        xs={12}
         
        sx={{ height: "81.3vh", overflow: "auto" }}
      >
        {userInfo.rolesInfo.title.toLowerCase() == "trainer" && (
          <ContinueTeaching></ContinueTeaching>
        )}
        <Root></Root>
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default Module;
